// react imports
import React, { useState, useContext, useEffect } from "react";

// react router dom
import { useNavigate } from "react-router";

// prime react imports
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn
} from 'mdb-react-ui-kit';
import AppContext from "../../../AppContext";
import i18n from "../../../i18n";
import Moment from 'moment';
import { renderTextWithNewLines } from "../../../data/helper-funcs";


/**
 * Props
 * @param messageId: true
 * @param hideModal: () =>  {}
 * @param reply: (orderId, recipientId, recipientPublicName, subject) => {}
 * @param delete: (messageId) => {}
 * @returns
 */
const MessageModal = (props) => {
  const context = useContext(AppContext);

  // MULTILANGUAGE
  const { t } = i18n

  // STATE
  const [message, setMessage] = useState(null);
  const [legalDate, setLegalDate] = useState();
  

  // HELPER FUNCS
  const getName = (id, name) => {
    return (context.isLoggedInIdIs(id) ? t('messages.you') : name);
  };
  const closeModal = () => {
    props.hideModal();
    
    setTimeout(() => {
      setMessage(null);
    }, 500);
  };


  useEffect(() => {
    if (!props.messageId) {
      return;
    }

    if (message?.id !== props.messageId) {
      setMessage(null);
    }
    context.interAxios.get('/message/' + props.messageId, function(response) {
      setMessage(response.data)
      const now = new Date();
      now.setDate(now.getDate() - 30)
      setLegalDate(new Date(response.data.order.timestamp)>now)
      console.log(new Date(response.data.order.timestamp))
    })

   /* setTimeout(() => {
      setMessage({
        "id": 123,
        "sender": {
          "id": 123,
          "image": {
            "id": 123,
            "url": "https://servername:port/storage/..."
          },
          "publicName": "string"
        },
        "recipient": {
          "id": 123,
          "image": {
            "id": 123,
            "url": "https://servername:port/storage/..."
          },
          "publicName": "string"
        },
        "order": {
          "firstImage": {
            "id": 123,
            "url": "https://servername:port/storage/..."
          },
          "title": "string",
          "grossPrice": 0,
          "timestamp": 0,
          "buyer": {
            "id": 123,
            "image": {
              "id": 123,
              "url": "https://servername:port/storage/..."
            },
            "publicName": "string",
            "rating": {
              "stars": 5,
              "count": 0
            },
            "profileUrl": "https://servername:port/storage/...",
            "isFollowed": true,
            "email": "user@example.com",
            "phoneNumber": "string",
            "location": "string"
          },
          "shippingOption": {
            "name": "PICKUP",
            "price": 0
          },
          "shippingAddress": {
            "location": "string",
            "countryCode": "KF",
            "postcode": 9999,
            "address": "string",
            "lastName": "string",
            "firstName": "string"
          },
          "seller": {
            "id": 123,
            "image": {
              "id": 123,
              "url": "https://servername:port/storage/..."
            },
            "publicName": "string",
            "rating": {
              "stars": 5,
              "count": 0
            },
            "profileUrl": "https://servername:port/storage/...",
            "isFollowed": true,
            "email": "user@example.com",
            "phoneNumber": "string",
            "location": "string"
          },
          "size": {
            "id": 123,
            "name": "string"
          },
          "buyerReview": {
            "id": 123,
            "buyer": {
              "id": 123,
              "image": {
                "id": 123,
                "url": "https://servername:port/storage/..."
              },
              "publicName": "string"
            },
            "seller": {
              "id": 123,
              "image": {
                "id": 123,
                "url": "https://servername:port/storage/..."
              },
              "publicName": "string"
            },
            "item": {
              "firstImage": {
                "id": 123,
                "url": "https://servername:port/storage/..."
              },
              "title": "string",
              "grossPrice": 0
            },
            "created": 0,
            "content": "string",
            "star": 5
          }
        },
        "text": "Lorem ipsum dolor sit amet, qui elitr torquatos scripserit ut, vis id causae theophrastus, pro consul perpetua te. Impedit nusquam usu eu, ponderum torquatos liberavisse ea duo. Meis accusata an sea. Laboramus democritum sententiae pro at, no reque petentium cum, malis possim accusata qui in. Ut pro iriure impedit.\n\n Vim ullum prodesset concludaturque in, et usu ferri voluptaria. Quo in oblique accusamus sadipscing, patrioque signiferumque pro in. Nec ad soluta civibus. Aperiam fabulas sed an, eu sed quis eius utroque. Movet dicam duo an. Usu ex eros epicurei lucilius, prompta lucilius te cum, stet legendos persecuti ex vis. Sanctus repudiare ad his."
      });
    }, 1000)*/
  }, [props.messageId]);

 
  return (
    <MDBModal
      className="standard-jc-modal w-615 message-modal"
      show={Number.isInteger(props.messageId)}
      backdrop={true}
      staticBackdrop={true}
      tabIndex='-1'
      onHidePrevented={props.hideModal}
    >
      <MDBModalDialog centered>
        <MDBModalContent>
          <MDBModalHeader>
            {/* <MDBModalTitle>Modal title</MDBModalTitle> */}
            <MDBBtn className='btn-close' color='none'  type='button' onClick={props.hideModal}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>

            {!message && (
              <i className="fa-regular fa-spinner-third spinning"></i>
            )}

            {message && (
             <>
                <header>
                  <div className="header-content">
                    <h2>{message?.order?.title}</h2>
  
                    <div>
                      <strong>From: </strong> {getName(message?.sender?.id, message?.sender.publicName)}
                    </div>
                    <div>
                      <strong>To: </strong> {getName(message?.recipient?.id, message?.recipient.publicName)}
                    </div>
                    <div className="date">
                      <strong><i className="fa-regular fa-clock"></i> </strong> {Moment(message?.timestamp).format('DD.MM.YYYY HH:mm')}
                    </div>
                  </div>
                </header>
                
                <div className="text">
                  {renderTextWithNewLines(message?.text)}
                </div>

                <div className="buttons">
                  {context.isLoggedInIdIs(message?.recipient.id) && legalDate && ( 
                    <button 
                      className="jc-btn reply brown"
                      onClick={() => props.reply(message.order.id, message.sender.id, message.sender.publicName, message.order.title)}
                    >
                      <i className="fa-regular fa-reply"></i>
                      <span>{t('messages.reply')}</span>
                    </button>
                  )}

                  <button 
                    className="jc-btn white delete"
                    onClick={() => props.delete(message.id)}
                  >
                    <i className="fa-regular fa-trash-alt"></i>
                    <span>{t('messages.delete')}</span>
                  </button>
                </div>
             </>
            )}
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

export default MessageModal;
